import { IOfferCard } from '../../../types';

export function getAgentFee(offerCard: IOfferCard): string {
  const { agentFee, clientFee } = offerCard.bargainTerms;
  const fee: string[] = [];

  if (agentFee != null) {
    fee.push(`аг.\u00A0${agentFee}%`);
  }

  if (clientFee != null) {
    fee.push(`кл.\u00A0${clientFee}%`);
  }

  return fee.join(', ');
}
